import { CollaboratorsApiRemoteService } from '../../Services/api/collaborators/collaborators-service'
import {  ICollaboratorEntity, IUpdateCollaboratorPayload } from '../../Services/api/collaborators/collaborators.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdateCollaboratorsUseCase
implements IFormUsecase<IUpdateCollaboratorPayload, void> {
  constructor (private readonly CollaboratorsApi: CollaboratorsApiRemoteService) {}
    

  public async handle (
    data: IUpdateCollaboratorPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CollaboratorsApi.update(data)

      if (response.isFailure) {
        return response
      }
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
